import React, { createContext, useContext, useState } from 'react'

import { ToastMessage } from '@/components/custom-components'

export interface Message {
    message: string
    type: 'success' | 'info' | 'warning' | 'error' | 'customColor'
    customColor?: string
    title?: string
    subtitle?: string
}

interface MessageContextType {
    showMessage: (message: Message) => void
}

const ToasMessageProvider = createContext<MessageContextType | undefined>(
    undefined
)

interface MessageProviderProps {
    children: React.ReactNode
}
export const ToastMessageProvider: React.FC<MessageProviderProps> = ({
    children
}) => {
    const [currentMessage, setCurrentMessage] = useState<Message | null>(null)
    const [isVisible, setIsVisible] = useState(false)

    const showMessage = (message: Message): void => {
        setCurrentMessage(message)
        setIsVisible(true)
        setTimeout(() => {
            setIsVisible(false)
            setTimeout(() => {
                setCurrentMessage(null)
            }, 300) // Wait for exit animation to complete
        }, 3000)
    }

    return (
        <ToasMessageProvider.Provider value={{ showMessage }}>
            {children}
            <div className="fixed inset-0 pointer-events-none z-[9999]">
                {currentMessage && (
                    <ToastMessage
                        message={currentMessage.message}
                        type={currentMessage.type}
                        customColor={currentMessage.customColor}
                        title={currentMessage.title}
                        description={currentMessage.subtitle}
                        visible={isVisible}
                        onClose={() => setIsVisible(false)}
                        position="top-right"
                    />
                )}
            </div>
        </ToasMessageProvider.Provider>
    )
}
export const useToastMessage = (): MessageContextType => {
    const context = useContext(ToasMessageProvider)

    if (!context) {
        throw new Error('useMessage must be used within a MessageProvider')
    }

    return context
}
